// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__bChXR","buttons":"RemoveExpirationActionButtons_buttons__3UFXG"};